import { httpCreate } from './http';
const http = httpCreate('/srv/iconSwitch');
export const iconSwitch = {
	relationPhoto(activityId, data) {
		return http.post(`/relationPhoto/${activityId}`, data);
	},
	save(activityId, data, params) {
		return http.post(`/save/${activityId}`, data, { params });
	},
	saveModel(activityId, data) {
		return http.post(`/saveModel/${activityId}`, data);
	},
	//竖屏直播获取功能
	vertical(activityId) {
		return http.get(`/getModel/vertical/${activityId}`);
	},
	getModel(activityId) {
		return http.get(`/getModel/${activityId}`);
	},
	//更新直播开关
	updateLiveModel(activityId, status, data) {
		return http.post(`/updateLiveModel/${activityId}/${status}`, data);
	},
	//仅剩1个菜单的对其方式
	menuAlignments(activityId, data) {
		return http.post(`/save/${activityId}`, data);
	},
};
